<template>
    <Toolbar v-if="data.toolbar !== undefined" :class="data.toolbar.class || 'bg-white p-0'">
        <template #start>
            <div v-if="data.toolbar.leftSide && data.toolbar.leftSide.buttons">
                <template v-for="(item, index) in data.toolbar.leftSide.buttons" :key="index">
                    <button
                        v-if="item.private === undefined || !item.private"
                        :class="`me-sm-2 btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="item.eventCallback(parentobj, $event)"
                    >
                        <i :class="`me-1 ${item.icon}`"></i>
                        {{item.label}}
                    </button>
                </template>
            </div>
        </template>
        <template #end>
            <div v-if="data.toolbar.rightSide && data.toolbar.rightSide.buttons">
                <template v-for="(item, index) in data.toolbar.rightSide.buttons" :key="index">
                    <button
                        v-if="item.private === undefined || !item.private"
                        :class="`me-sm-2 btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="item.eventCallback(parentobj, $event)"
                    >
                        <i :class="`me-1 ${item.icon}`"></i>
                        {{item.label}}
                    </button>
                </template>
            </div>
        </template>
    </Toolbar>
</template>


<script>
    import Toolbar from "primevue/toolbar";
    // import Button from "primevue/button";

    import { useModelWrapper } from "@/utils/modelWrapper";

    export default {
        name: 'ModalToolbar',
        props: {
            data: {
                type: Object,
                default(){
                    return null;
                }
            },
            mainref: {
                type: Object,
                default(){
                    return null;
                }
            },
        },
        components: {
            Toolbar,
            // Button,
        },
        setup(props, { emit }) {
            const parentobj = useModelWrapper(props, emit, "mainref");

            return {
                parentobj,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .p-toolbar {
        padding: 0.8rem;
        border: unset;
    }
</style>
